import { datadogLogs } from '@datadog/browser-logs';
import { isAxiosNetworkError } from '../common/axiosApiClient';
import { UserEventTypes } from './user-events.types';

// For this particular call to log events, do not let errors bubble up
// to a react error boundary. Just report them.
export const logEvent = async (event: UserEventTypes, listingId?: number) => {
  try {
    // event log API will fail if there is no match on listingId
    await globalThis.axiosApiClient.post(`user-event/log`, { event, listingId });
  } catch (error: any) {
    // do not log network errors
    if (isAxiosNetworkError(error)) return;

    datadogLogs.logger.error(
      `Unable to track event: ${event} ${listingId ? `for listing ${listingId}` : ''}: ${error.message}`,
      {
        stack: error.stack,
        name: error.name,
      },
      error,
    );
  }
};
